import { useAttrs, computed, openBlock, createBlock, mergeProps, createSlots, renderList, withCtx, renderSlot, normalizeProps, guardReactiveProps } from "vue";
import UikitInputNew from "./InputNew.vue.es.js";
import { INPUT_NUMBER_PROPS } from "./input.es.js";
const _sfc_main = {
  __name: "InputPriceNew",
  props: INPUT_NUMBER_PROPS,
  emits: ["update:modelValue", "onChange"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const props = __props;
    const attrs = useAttrs();
    const inputProps = computed(() => ({
      ...attrs,
      ...props,
      syncVModel: false,
      inputMode: "numeric",
      valueFormatter,
      displayedValueFormatter
    }));
    const handleValueUpdate = (value) => {
      emit("update:modelValue", value);
    };
    const handleChange = (value) => {
      emit("onChange", value);
    };
    const stripNonNumber = (value) => {
      if (props.allowNegative) {
        return value.replace(/[^\-?\d.,]/g, "");
      } else {
        return value.replace(/[^\d.,]/g, "");
      }
    };
    const replacePointToComma = (value) => {
      return value.replaceAll(".", ",");
    };
    const replaceCommasToPoint = (value) => {
      return value.replaceAll(",", ".");
    };
    const removeExceedingPoints = (value) => {
      if (value[0] === ".") {
        return void 0;
      }
      const output = value.split(".");
      return output.shift() + (output.length ? "." + output.join("") : "");
    };
    const removeExceedingDecimals = (value) => {
      const output = value.split(".");
      if (output.length === 0 || output.length === 1) {
        return value;
      }
      if (props.decimals === 0) {
        return output[0];
      }
      return output[0] + "." + output[1].substr(0, props.decimals);
    };
    const numberWithSpace = (value) => {
      const parts = `${value}`.split(",");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      return parts.join(",");
    };
    const removeSpaceFromNumber = (value) => {
      return value.replace(/\s/g, "");
    };
    const handleMinMax = (numberValue) => {
      if (typeof props.min === "number" && numberValue < props.min) {
        return props.min;
      }
      if (typeof props.max === "number" && numberValue > props.max) {
        return props.max;
      }
      return numberValue;
    };
    const valueFormatter = (value) => {
      if (value === void 0 || value === null || value === "") {
        return void 0;
      }
      let localValue = removeSpaceFromNumber(`${value}`);
      if (!localValue.length) {
        return void 0;
      }
      let formattedNumber = stripNonNumber(localValue);
      formattedNumber = replaceCommasToPoint(formattedNumber);
      formattedNumber = removeExceedingPoints(formattedNumber);
      if (formattedNumber === void 0) {
        return void 0;
      }
      formattedNumber = removeExceedingDecimals(formattedNumber);
      let numberValue = 1 * formattedNumber;
      return handleMinMax(numberValue);
    };
    const displayedValueFormatter = (value) => {
      if (value === void 0 || value === null || value === "") {
        return void 0;
      }
      let localValue = removeSpaceFromNumber(`${value}`);
      if (!localValue.length) {
        return void 0;
      }
      let formattedNumber = stripNonNumber(localValue);
      formattedNumber = replaceCommasToPoint(formattedNumber);
      formattedNumber = removeExceedingPoints(formattedNumber);
      if (formattedNumber === void 0) {
        return void 0;
      }
      formattedNumber = removeExceedingDecimals(formattedNumber);
      let endWithDotOrFullZeroRegex = /(\.0*)$/;
      const match = formattedNumber.match(endWithDotOrFullZeroRegex);
      if (match) {
        const endPart = match[0];
        let numberValue = 1 * formattedNumber.slice(0, formattedNumber.length - endPart.length);
        numberValue = handleMinMax(numberValue);
        return numberWithSpace(replacePointToComma(`${numberValue}${endPart}`));
      } else {
        let numberValue = 1 * formattedNumber;
        numberValue = handleMinMax(numberValue);
        return numberWithSpace(replacePointToComma(`${numberValue}`));
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(UikitInputNew, mergeProps(inputProps.value, {
        class: "uikit-input-price",
        "onUpdate:modelValue": handleValueUpdate,
        onOnChange: handleChange
      }), createSlots({ _: 2 }, [
        renderList(_ctx.$slots, (_, name) => {
          return {
            name,
            fn: withCtx((slotData) => [
              renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(slotData)))
            ])
          };
        })
      ]), 1040);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=InputPriceNew.vue.es.js.map
